export default __webpack_public_path__ + "static/media/GreenPlus.d2d329b0.svg";